/*
 * Mudgee Meat delivery selector
 * Front-end only. Uses Bundlfresh's two endpoints (suburbs + dates) and keeps
 * their cart attribute names ("Delivery Date", "Delivery Location") so their
 * order allocation keeps working.
 *
 * Mount points (any number, all kept in sync):
 *   <div data-mm-delivery="topbar"></div>
 *   <div data-mm-delivery="cart"></div>
 */
(function () {
  if (window.__mmDelivery) return;
  window.__mmDelivery = true;

  var cfg = Object.assign(
    {
      clientId: 'FiCuQ4s3t4aH',
      apiBase: '/apps/bfc/service/',
      maxDays: 61, // furthest bookable date: about 2 months ahead (0 = no cap)
      blockedDates: [], // extra closures, 'YYYY-MM-DD'
      // Mudgee and surrounds (2850 etc.) are Trev's own Wednesday run (the feed also lists Mon/Sat, which we do not use)
      trevWednesdayPostcodes: ['2850'],
      // Gulgong (2852): Trev's Wednesday plus BeCool's days from the feed
      trevWednesdayPlusBecoolPostcodes: ['2852'],
      // Trev's Wednesday run is only these suburbs: along the Gulgong to Mudgee road and within about 20 minutes' drive of it.
      // Every other suburb in these postcodes is BeCool only (Sat/Mon from the feed), or no delivery if the feed has no dates.
      trevWedSuburbs: {
        '2850': ['Apple Tree Flat', 'Avisford', 'Bombira', 'Buckaroo', 'Budgee Budgee', 'Burrundulla', 'Caerleon', 'Canadian Lead', 'Collingwood', 'Cross Roads', 'Cudgegong', 'Cullenbone', 'Cumbo', 'Erudgere', 'Eurunderee', 'Frog Rock', 'Galambine', 'Glen Ayr', 'Grattai', 'Havilah', 'Home Rule', 'Menah', 'Milroy', 'Millsville', 'Mount Frome', 'Mount Knowles', 'Mudgee', 'Mullamuddy', 'Putta Bucca', 'Spring Flat', 'St Fillans', 'Wilbetree'],
        '2852': ['Beryl', 'Biraganbil', 'Cope', 'Cumbandry', 'Gulgong', 'Guntawang', 'Stubbo', 'Tallawang', 'Two Mile Flat']
      },
      // Suburbs on Trev's Wednesday run that also get BeCool's days (Sat/Mon from the feed)
      trevWedPlusBecoolSuburbs: { '2850': ['Avisford'] },
      // Trev's Wednesdays are generated here (not taken from the feed): earliest is this many days from today, up to the horizon, skipping the closure range
      trevWedMinDays: 3,
      trevWedHorizonDays: 61,
      trevWedBlockedRanges: [['2026-12-21', '2027-01-07']],
      // Suburbs in these postcodes with no dates in the feed borrow this suburb's Wednesdays (Trev's Mudgee run); list any suburbs too far out in trevExcludedSuburbs
      trevFallbackSuburb: { '2850': 'Mudgee', '2852': 'Gulgong' },
      trevExcludedSuburbs: [],
      // BeCool: furthest delivery day after the Thursday drop (Thu = 0, Fri 1, Sat 2, Sun 3, Mon 4, Tue 5, Wed 6)
      shortMaxDays: 3, // postcodes delivered from Friday (Fri to Tue in the feed): up to Sunday
      longMaxDays: 5, // long haul (first delivery later than Friday): up to Tuesday, or Wednesday if Wednesday is their first date
      // Bundlfresh's feed already blocks 21 Dec to 3 Jan, so we only cover the rest: no deliveries 4 to 7 Jan (BeCool receives stock again Thu 7 Jan)
      blockedRanges: [['2027-01-04', '2027-01-07']],
      requireLeaveAt: false
    },
    window.MM_DELIVERY || {}
  );

  var MSG_NO_POSTCODE = "Sorry, we don't deliver to this postcode.";
  var MSG_NO_SUBURB = "Sorry, we don't deliver to this suburb.";
  var MSG_NO_DATES = "We're not taking delivery dates for this area yet. Please check back soon.";
  var MSG_ERROR = "We couldn't check that just now. Please try again.";
  var DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  /* ---------- state ---------- */
  var state = {
    zipInput: '',
    zip: '',
    suburb: '',
    suburbs: [],
    dates: [], // sorted epoch ms (UTC midnight of the delivery date)
    dateMs: null,
    status: 'idle', // idle | loading | ready | nopostcode | nosuburb | error
    leaveAt: '',
    gate: '',
    showErrors: false
  };

  /* ---------- helpers ---------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function setCookie(name, val, days) {
    try {
      var exp = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = name + '=' + encodeURIComponent(val) + '; expires=' + exp + '; path=/; SameSite=Lax';
    } catch (e) {}
  }
  function getCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  function store(key, val) { try { sessionStorage.setItem(key, val); } catch (e) {} }
  function load(key) { try { return sessionStorage.getItem(key) || ''; } catch (e) { return ''; } }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  // Dates from the endpoint are UTC midnight of the delivery day, so always read UTC parts.
  function parts(ms) { var d = new Date(ms); return { y: d.getUTCFullYear(), m: d.getUTCMonth(), d: d.getUTCDate(), wd: (d.getUTCDay() + 6) % 7 }; }
  function iso(ms) { var p = parts(ms); return p.y + '-' + pad(p.m + 1) + '-' + pad(p.d); }
  function auDate(ms) { var p = parts(ms); return pad(p.d) + '/' + pad(p.m + 1) + '/' + p.y; } // same as toLocaleDateString('en-AU')
  function nice(ms) { var p = parts(ms); return DAYS[p.wd] + ' ' + p.d + ' ' + MONTHS[p.m].slice(0, 3) + ' ' + p.y; }
  function weekStart(ms) { var p = parts(ms); return ms - p.wd * 864e5; } // Monday
  function niceShort(ms) { var p = parts(ms); return DAYS[p.wd] + ' ' + p.d + ' ' + MONTHS[p.m].slice(0, 3); }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function complete() {
    var ok = !!(state.zip && state.suburb && state.dateMs && state.dates.indexOf(state.dateMs) > -1);
    if (ok && cfg.requireLeaveAt && state.leaveAt.replace(/\s/g, '') === '') ok = false;
    return ok;
  }

  /* ---------- data ---------- */
  function loadSuburbs(zip) {
    state.status = 'loading';
    state.suburbs = []; state.dates = []; state.suburb = ''; state.dateMs = null;
    emit();
    return getJSON(cfg.apiBase + 'suburbs.bfn?id=' + encodeURIComponent(cfg.clientId) + '&zip=' + encodeURIComponent(zip))
      .then(function (list) {
        if (zip !== state.zip) return; // superseded
        var names = (Array.isArray(list) ? list : []).map(function (o) { return o && o.value; }).filter(Boolean);
        state.suburbs = names;
        if (!names.length) { state.status = 'nopostcode'; emit(); return; }
        state.status = 'ready';
        emit();
      })
      .catch(function () { if (zip === state.zip) { state.status = 'error'; emit(); } });
  }

  /*
   * Delivery rules by courier.
   * Trev (own truck): only the Mudgee area, on Wednesdays (see trevWedSuburbs). His Thursday run has ended.
   * BeCool (everyone else): stock is dropped to BeCool each Thursday, never delivered on a Thursday, and must
   * be delivered within 7 days of that drop. A postcode's transit time is read from the feed: its first
   * non-Thursday date sits that many days after the Thursday drop. Dates that would need the previous
   * Thursday's drop (older than 7 days) are hidden.
   */
  function plusBecool(zip, sub) { return ((cfg.trevWedPlusBecoolSuburbs || {})[zip] || []).indexOf(sub) > -1; }
  function becoolOnly(zip, sub) { var w = (cfg.trevWedSuburbs || {})[zip]; return w ? w.indexOf(sub) === -1 : false; } // not on Trev's Wednesday run
  function filterDates(raw, zip, today, sub) {
    var inList = function (l) { return (cfg[l] || []).indexOf(zip) > -1; };
    var dow = function (ms) { return new Date(ms).getUTCDay(); };
    var off = function (ms) { return (dow(ms) + 3) % 7; }; // days since the last Thursday (Thu = 0)
    if (inList('trevWednesdayPostcodes') && !becoolOnly(zip, sub) && !plusBecool(zip, sub)) return raw.filter(function (ms) { return dow(ms) === 3; });
    var nonThu = raw.filter(function (ms) { return dow(ms) !== 4; }).sort(function (a, b) { return a - b; });
    var m = 2; // safe default: Friday hidden
    if (nonThu.length && (nonThu[0] - today) / 864e5 <= 12) m = Math.max(1, off(nonThu[0]));
    var near = nonThu.length && (nonThu[0] - today) / 864e5 <= 12;
    var z = Number(zip), cap;
    if (!near) cap = (z >= 2000 && z <= 2234) ? cfg.shortMaxDays : cfg.longMaxDays; // first date unknown (near a closure): Sydney metro short, the rest long
    else if (off(nonThu[0]) <= 1) cap = cfg.shortMaxDays;
    else cap = Math.max(cfg.longMaxDays, off(nonThu[0]));
    return raw.filter(function (ms) {
      if (dow(ms) === 4) return false; // nothing is delivered on a Thursday
      return off(ms) >= m && off(ms) <= cap;
    });
  }
  window.__mmFilter = filterDates;

  // Trev's own Wednesdays, generated (independent of the feed's lead time)
  function trevWeds(zip, today, sub) {
    var plus = (cfg.trevWednesdayPlusBecoolPostcodes || []).indexOf(zip) > -1 || plusBecool(zip, sub);
    var own = (cfg.trevWednesdayPostcodes || []).indexOf(zip) > -1 && !plus;
    if (!own && !plus) return null;
    var list = [];
    for (var ms = today + cfg.trevWedMinDays * 864e5; ms <= today + cfg.trevWedHorizonDays * 864e5; ms += 864e5) {
      if (new Date(ms).getUTCDay() !== 3) continue;
      var day = iso(ms);
      if ((cfg.trevWedBlockedRanges || []).some(function (r) { return day >= r[0] && day <= r[1]; })) continue;
      list.push(ms);
    }
    return { own: own, list: list };
  }
  window.__mmTrevWeds = trevWeds;

  function datesUrl(zip, sub) { return cfg.apiBase + 'dates.bfn?id=' + encodeURIComponent(cfg.clientId) + '&zip=' + encodeURIComponent(zip) + '&suburb=' + encodeURIComponent(sub); }
  // Mudgee-run suburbs that the feed lists but gives no dates for borrow the reference suburb's dates
  function fetchDates(zip, sub) {
    return getJSON(datesUrl(zip, sub)).then(function (list) {
      var ref = (cfg.trevFallbackSuburb || {})[zip];
      var skip = (cfg.trevExcludedSuburbs || []).indexOf(sub) > -1 || becoolOnly(zip, sub);
      if (Array.isArray(list) && list.length === 0 && ref && !skip && sub !== ref) return getJSON(datesUrl(zip, ref));
      return list;
    });
  }

  function loadDates() {
    var zip = state.zip, suburb = state.suburb;
    if (!zip || !suburb) return Promise.resolve();
    state.status = 'loading'; emit();
    return fetchDates(zip, suburb)
      .then(function (list) {
        if (zip !== state.zip || suburb !== state.suburb) return;
        var today = new Date(); today = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
        var blocked = {}; (cfg.blockedDates || []).forEach(function (d) { blocked[d] = 1; });
        var raw = (Array.isArray(list) ? list : []).map(function (o) { return Number(o && o.value); }).filter(Boolean);
        var base = filterDates(raw, zip, today, suburb);
        var tw = (raw.length && !becoolOnly(zip, suburb)) ? trevWeds(zip, today, suburb) : null;
        if (tw) base = tw.own ? tw.list : base.concat(tw.list.filter(function (ms) { return base.indexOf(ms) === -1; }));
        var out = base
          .filter(function (ms) {
            var day = iso(ms);
            if ((cfg.blockedRanges || []).some(function (r) { return day >= r[0] && day <= r[1]; })) return false;
            if (blocked[day]) return false;
            if (cfg.maxDays && ms > today + cfg.maxDays * 864e5) return false;
            return true;
          }).sort(function (a, b) { return a - b; });
        state.dates = out;
        if (!out.length) { state.status = raw.length ? 'nodates' : 'nosuburb'; state.dateMs = null; }
        else { state.status = 'ready'; if (out.indexOf(state.dateMs) === -1) state.dateMs = null; }
        persist(); emit();
      })
      .catch(function () { if (zip === state.zip && suburb === state.suburb) { state.status = 'error'; emit(); } });
  }

  function setZip(zip) {
    zip = (zip || '').replace(/\D/g, '').slice(0, 4);
    state.zipInput = zip;
    if (zip.length < 4) { state.zip = ''; state.suburbs = []; state.dates = []; state.suburb = ''; state.dateMs = null; state.status = 'idle'; persist(); emit(); return Promise.resolve(); }
    if (zip === state.zip && state.suburbs.length) return Promise.resolve();
    state.zip = zip;
    return loadSuburbs(zip).then(function () {
      if (state.suburbs.length === 1) { state.suburb = state.suburbs[0]; return loadDates(); }
      persist();
    });
  }

  function setSuburb(name) {
    state.suburb = name; state.dateMs = null; state.dates = [];
    persist();
    if (!name) { emit(); return Promise.resolve(); }
    return loadDates();
  }

  function setDate(ms) {
    state.dateMs = ms; persist(); emit(); writeAttributes();
  }

  /* ---------- persistence + cart attributes ---------- */
  function persist() {
    setCookie('_zip', state.zip || '', 7);
    setCookie('_suburb', state.suburb || '', 7);
    setCookie('_date', state.dateMs ? String(state.dateMs) : '', 1);
    store('mm_leave', state.leaveAt); store('mm_gate', state.gate);
  }

  // Also put a short summary in Shopify's main order Notes box so staff see it straight away.
  function composeNote(existing, ok) {
    if (existing === null) return null;
    var keep = String(existing).split('\n').filter(function (l) { return !/^(Delivery|Order notes|Gate code): /.test(l); });
    var mine = [];
    if (ok) mine.push('Delivery: ' + nice(state.dateMs) + ' to ' + state.suburb + ' ' + state.zip);
    if (state.leaveAt.trim()) mine.push('Order notes: ' + state.leaveAt.trim().replace(/\s*\n\s*/g, ' '));
    if (state.gate.trim()) mine.push('Gate code: ' + state.gate.trim());
    return mine.concat(keep).join('\n').trim();
  }

  var writeTimer;
  function writeAttributes() {
    clearTimeout(writeTimer);
    writeTimer = setTimeout(function () {
      var ok = state.zip && state.suburb && state.dateMs;
      var a = {
        'Delivery Date': ok ? auDate(state.dateMs) : '', // same format Bundlfresh's own script writes
        'Delivery Location': ok ? state.suburb + ', ' + state.zip : '', // same as Bundlfresh
        'Delivery Date ISO': ok ? iso(state.dateMs) : '',
        'Delivery Week Starting': ok ? iso(weekStart(state.dateMs)) : '',
        'Delivery Postcode': ok ? state.zip : '',
        'Delivery Suburb': ok ? state.suburb : '',
        'Order Notes': state.leaveAt.trim(),
        'Gate Code': state.gate.trim()
      };
      var ta = document.getElementById('Cart-note');
      var send = function (existing) {
        var body = { attributes: a };
        var note = composeNote(existing, ok);
        if (note !== null) { body.note = note; if (ta) ta.value = note; }
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      };
      (ta ? Promise.resolve(ta.value) : getJSON('/cart.js').then(function (c) { return c.note || ''; }))
        .then(send, function () { return send(null); })
        .catch(function () {});
    }, 350);
  }

  /* ---------- rendering ---------- */
  var ICON = {
    search: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>',
    cal: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg>',
    caret: '<svg viewBox="0 0 12 8" width="12" height="8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1.5l5 5 5-5"/></svg>',
    tick: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  var ui = { calOpen: false, calHost: -1, calYM: null };

  function message() {
    if (state.status === 'nopostcode') return MSG_NO_POSTCODE;
    if (state.status === 'nosuburb') return MSG_NO_SUBURB;
    if (state.status === 'nodates') return MSG_NO_DATES;
    if (state.status === 'error') return MSG_ERROR;
    return '';
  }

  function suburbSelect(id) {
    var disabled = !state.suburbs.length || state.status === 'loading';
    var opts = '<option value="">Select suburb</option>' + state.suburbs.map(function (s) {
      return '<option value="' + esc(s) + '"' + (s === state.suburb ? ' selected' : '') + '>' + esc(s) + '</option>';
    }).join('');
    return '<div class="mm-d__select"><select id="' + id + '" data-mm="suburb" aria-label="Suburb"' + (disabled ? ' disabled' : '') + '>' + opts + '</select><span class="mm-d__caret">' + ICON.caret + '</span></div>';
  }

  function zipField(id) {
    return '<div class="mm-d__zip"><input id="' + id + '" data-mm="zip" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="4" placeholder="Enter postcode" aria-label="Postcode" value="' + esc(state.zipInput) + '">' +
      '<button type="button" data-act="search" aria-label="Check postcode">' + ICON.search + '</button></div>';
  }

  function dateField(id, idx) {
    var enabled = state.dates.length > 0;
    var open = ui.calOpen && ui.calHost === idx;
    var label = state.dateMs ? nice(state.dateMs) : 'Select a date';
    return '<div class="mm-d__date' + (state.dateMs ? ' has-value' : '') + '">' +
      '<button type="button" id="' + id + '" class="mm-d__datebtn" data-act="cal" aria-haspopup="dialog" aria-expanded="' + open + '"' + (enabled ? '' : ' disabled') + '>' + ICON.cal + '<span>' + esc(label) + '</span></button>' +
      (open && enabled ? calendar() : '') + '</div>';
  }

  function calendar() {
    var first = state.dateMs || state.dates[0];
    if (!ui.calYM) { var p0 = parts(first); ui.calYM = { y: p0.y, m: p0.m }; }
    var y = ui.calYM.y, m = ui.calYM.m;
    var minP = parts(state.dates[0]), maxP = parts(state.dates[state.dates.length - 1]);
    var minIdx = minP.y * 12 + minP.m, maxIdx = maxP.y * 12 + maxP.m, cur = y * 12 + m;
    var set = {}; state.dates.forEach(function (ms) { set[ms] = 1; });
    var startWd = (new Date(Date.UTC(y, m, 1)).getUTCDay() + 6) % 7;
    var dim = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
    var cells = '';
    for (var i = 0; i < startWd; i++) cells += '<span class="mm-cal__blank"></span>';
    for (var d = 1; d <= dim; d++) {
      var ms = Date.UTC(y, m, d), on = !!set[ms], sel = ms === state.dateMs;
      cells += on
        ? '<button type="button" class="mm-cal__day' + (sel ? ' is-selected' : '') + '" data-act="pick" data-ms="' + ms + '" aria-label="' + esc(nice(ms)) + '"' + (sel ? ' aria-pressed="true"' : '') + '>' + d + '</button>'
        : '<span class="mm-cal__day is-off" aria-hidden="true">' + d + '</span>';
    }
    return '<div class="mm-cal" role="dialog" aria-label="Choose a delivery date">' +
      '<div class="mm-cal__head"><button type="button" data-act="prev" aria-label="Previous month"' + (cur <= minIdx ? ' disabled' : '') + '>&#8249;</button>' +
      '<strong>' + MONTHS[m] + ' ' + y + '</strong>' +
      '<button type="button" data-act="next" aria-label="Next month"' + (cur >= maxIdx ? ' disabled' : '') + '>&#8250;</button></div>' +
      '<div class="mm-cal__dow">' + DAYS.map(function (d) { return '<span>' + d + '</span>'; }).join('') + '</div>' +
      '<div class="mm-cal__grid">' + cells + '</div>' +
      '<p class="mm-cal__note">Dates in blue are available for your area.</p></div>';
  }

  function missingList() {
    var missing = [];
    if (!state.zip || !state.suburb) missing.push('your postcode and suburb');
    else if (!state.dateMs) missing.push('a delivery date');
    if (cfg.requireLeaveAt && !state.leaveAt.trim()) missing.push('where we should leave your order');
    return missing;
  }

  function renderCart(host, idx) {
    var uid = 'mm' + Math.random().toString(36).slice(2, 7);
    var msg = message();
    var missing = missingList();
    var leaveErr = state.showErrors && cfg.requireLeaveAt && !state.leaveAt.trim();
    host.innerHTML =
      '<div class="mm-d mm-d--cart' + (complete() ? ' is-complete' : '') + '">' +
      '<h3 class="mm-d__h">Delivery details</h3>' +
      '<p class="mm-d__help">Enter your postcode and suburb to check if we deliver to you:</p>' +
      '<div class="mm-d__row' + (msg ? ' has-error' : '') + '">' + zipField(uid + 'z') + suburbSelect(uid + 's') + '</div>' +
      (msg ? '<p class="mm-d__err" role="alert">' + esc(msg) + '</p>' : '') +
      '<h3 class="mm-d__h">Delivery date</h3>' + dateField(uid + 'd', idx) +
      '<h3 class="mm-d__h">Order notes <span class="mm-d__opt">(optional)</span></h3>' +
      '<textarea class="mm-d__text' + (leaveErr ? ' is-invalid' : '') + '" data-mm="leave" rows="2" maxlength="200" placeholder="e.g. Leave at the front porch">' + esc(state.leaveAt) + '</textarea>' +
      '<p class="mm-d__small">Tell us where to leave your box or anything else we should know.</p>' +
      '<h3 class="mm-d__h">Gate code <span class="mm-d__opt">(optional)</span></h3>' +
      '<input class="mm-d__text mm-d__text--line" data-mm="gate" type="text" maxlength="40" placeholder="e.g. *456789#" value="' + esc(state.gate) + '">' +
      (complete()
        ? '<p class="mm-d__ok">' + ICON.tick + ' Delivering to ' + esc(state.suburb) + ' ' + esc(state.zip) + ' on ' + esc(nice(state.dateMs)) + '</p>'
        : '<p class="mm-d__gate' + (state.showErrors ? ' is-error' : '') + '" role="status">Please add ' + esc(missing.join(' and ')) + ' to check out.</p>') +
      '</div>';
  }

  function renderBar(host, idx) {
    var uid = 'mm' + Math.random().toString(36).slice(2, 7);
    var msg = message();
    var summary = complete() || (state.zip && state.suburb && state.dateMs);
    host.innerHTML =
      '<div class="mm-d mm-d--bar' + (summary ? ' is-complete' : '') + '">' +
      '<div class="mm-bar__inner">' +
      '<div class="mm-bar__group"><span class="mm-bar__label">Check when we deliver to you</span><div class="mm-d__row">' + zipField(uid + 'z') + suburbSelect(uid + 's') + '</div></div>' +
      '<div class="mm-bar__group"><span class="mm-bar__label">Choose your delivery date</span>' + dateField(uid + 'd', idx) + '</div>' +
      '</div>' +
      (msg ? '<p class="mm-d__err mm-bar__msg" role="alert">' + esc(msg) + '</p>'
        : (summary ? '<p class="mm-d__ok mm-bar__msg">' + ICON.tick + ' Delivering to ' + esc(state.suburb) + ' ' + esc(state.zip) + ' on ' + esc(nice(state.dateMs)) + '</p>' : '')) +
      '</div>';
  }

  var rendering = false;
  function render() {
    if (rendering) return; rendering = true;
    var active = document.activeElement, key = active && active.getAttribute && active.getAttribute('data-mm');
    var inHost = active && active.closest && active.closest('[data-mm-delivery]');
    var hostIdx = inHost ? qsa('[data-mm-delivery]').indexOf(inHost) : -1;
    var selStart = active && active.selectionStart, selEnd = active && active.selectionEnd;
    qsa('[data-mm-delivery]').forEach(function (host, idx) {
      // Don't rebuild a text field the person is typing in
      if (hostIdx === idx && (key === 'leave' || key === 'gate')) return;
      host.getAttribute('data-mm-delivery') === 'topbar' ? renderBar(host, idx) : renderCart(host, idx);
    });
    if (hostIdx > -1 && key && key !== 'leave' && key !== 'gate') {
      var host = qsa('[data-mm-delivery]')[hostIdx], el = host && qs('[data-mm="' + key + '"]', host);
      if (el && !el.disabled) { el.focus(); try { el.setSelectionRange(selStart, selEnd); } catch (e) {} }
    }
    rendering = false;
  }

  /* ---------- checkout gate ---------- */
  function applyGate() {
    var cartEmpty = !!qs('#main-cart-footer.is-empty');
    if (cartEmpty) return;
    var ok = complete();
    qsa('#checkout, button[name="checkout"], input[name="checkout"]').forEach(function (b) {
      b.disabled = !ok;
      b.setAttribute('aria-disabled', String(!ok));
      b.classList.toggle('mm-gated', !ok);
      b.title = ok ? '' : 'Complete your delivery details to check out';
    });
  }

  function emit() {
    render(); applyGate();
    document.dispatchEvent(new CustomEvent('mm:delivery', { detail: { complete: complete(), zip: state.zip, suburb: state.suburb, date: state.dateMs } }));
  }

  function block(e) {
    state.showErrors = true;
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    emit();
    var cart = qs('[data-mm-delivery="cart"]');
    if (cart && cart.scrollIntoView) cart.scrollIntoView({ behavior: 'smooth', block: 'center' });
    e.preventDefault(); e.stopPropagation();
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-act]');
    if (t && t.closest('[data-mm-delivery]')) {
      var act = t.getAttribute('data-act');
      var host = t.closest('[data-mm-delivery]');
      if (act === 'search') { var inp = qs('[data-mm="zip"]', host); setZip(inp ? inp.value : state.zipInput); }
      else if (act === 'cal') { var hi = qsa('[data-mm-delivery]').indexOf(host); ui.calOpen = !(ui.calOpen && ui.calHost === hi); ui.calHost = hi; ui.calYM = null; render(); }
      else if (act === 'prev' || act === 'next') {
        var d = act === 'prev' ? -1 : 1; var ym = ui.calYM; var n = ym.y * 12 + ym.m + d;
        ui.calYM = { y: Math.floor(n / 12), m: n % 12 }; render();
      } else if (act === 'pick') { ui.calOpen = false; setDate(Number(t.getAttribute('data-ms'))); }
      return;
    }
    if (ui.calOpen && !(e.target.closest && e.target.closest('.mm-d__date'))) { ui.calOpen = false; render(); }

    // Gate any route into checkout
    var link = e.target.closest && e.target.closest('a[href*="/checkout"], button[name="checkout"], #checkout, [data-shopify="payment-button"]');
    if (link && qs('[data-mm-delivery="cart"]') && !complete()) block(e);
  }, true);

  document.addEventListener('input', function (e) {
    var k = e.target.getAttribute && e.target.getAttribute('data-mm');
    if (k === 'zip') {
      var v = e.target.value.replace(/\D/g, '').slice(0, 4); e.target.value = v; state.zipInput = v;
      if (v.length === 4) setZip(v);
      else if (state.zip) setZip(v);
    } else if (k === 'leave') { state.leaveAt = e.target.value; persist(); applyGate(); writeAttributes(); softUpdate(); }
    else if (k === 'gate') { state.gate = e.target.value; persist(); writeAttributes(); }
  });

  // Update the status line without rebuilding the field being typed in
  function softUpdate() {
    qsa('.mm-d--cart').forEach(function (box) {
      box.classList.toggle('is-complete', complete());
      var g = qs('.mm-d__gate, .mm-d__ok', box);
      if (!g) return;
      if (complete()) {
        g.className = 'mm-d__ok';
        g.innerHTML = ICON.tick + ' Delivering to ' + esc(state.suburb) + ' ' + esc(state.zip) + ' on ' + esc(nice(state.dateMs));
      } else {
        g.className = 'mm-d__gate' + (state.showErrors ? ' is-error' : ''); g.textContent = 'Please add ' + missingList().join(' and ') + ' to check out.';
      }
      var ta = qs('[data-mm="leave"]', box); if (ta) ta.classList.remove('is-invalid');
    });
  }

  document.addEventListener('change', function (e) {
    var k = e.target.getAttribute && e.target.getAttribute('data-mm');
    if (k === 'suburb') setSuburb(e.target.value);
  });
  document.addEventListener('keydown', function (e) {
    var k = e.target.getAttribute && e.target.getAttribute('data-mm');
    if (e.key === 'Enter' && k === 'zip') { e.preventDefault(); setZip(e.target.value); }
    if (e.key === 'Escape' && ui.calOpen) { ui.calOpen = false; render(); }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action="/cart"], form#cart')) return;
    if (!qs('[data-mm-delivery="cart"]')) return;
    var s = e.submitter;
    if ((!s || s.name === 'checkout') && !complete()) block(e);
  }, true);

  /* ---------- boot ---------- */
  function boot() {
    state.zip = getCookie('_zip'); state.zipInput = state.zip;
    state.suburb = getCookie('_suburb');
    var d = Number(getCookie('_date')); state.dateMs = d || null;
    state.leaveAt = load('mm_leave'); state.gate = load('mm_gate');
    render(); applyGate();
    var cart = qs('#main-cart-footer');
    if (cart && window.MutationObserver) new MutationObserver(function () { applyGate(); }).observe(cart, { childList: true, subtree: true });
    if (state.zip) {
      var keep = state.suburb, keepDate = state.dateMs;
      loadSuburbs(state.zip).then(function () {
        if (keep && state.suburbs.indexOf(keep) > -1) { state.suburb = keep; state.dateMs = keepDate; return loadDates(); }
        if (state.suburbs.length === 1) { state.suburb = state.suburbs[0]; return loadDates(); }
      }).then(function () { if (complete()) writeAttributes(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
